{
  "validation.maxAttachments": "Du kan bara ladda upp {{max}} bilagor.",
  "validation.minAttachments": "Minst {{min}} bilagor behövs.",
  "validation.maxAttachmentSize": "Bilagor kan inte vara större än {{max}} megabyte.",
  "validation.attachmentListItemRequired": "Lägg till en bilaga för \"{{category}}",
  "validation.attachmentListItemMaxAttachments": "Endast {{max}} bilagor är tillåtna för kategorin \"{{category}}\".",
  "validation.attachmentListItemMaxAttachmentSize": "{{category}} bilagor kan inte vara större än {{max}} megabyte",
  "attachment.bsoCategory.DiagnosticReport": "Diagnosrapport",
  "attachment.bsoCategory.InvoiceDocument": "Fakturadokument",
  "attachment.bsoCategory.ShippingDocument": "Fraktdokument",
  "attachment.bsoCategory.Letter": "Brev",
  "attachment.bsoCategory.PictureReference": "Bildreferens",
  "attachment.bsoCategory.BugReport": "Felrapport",
  "attachment.bsoCategory.Other": "Övrigt",
  "attachment.bsoCategory.Unclassified": "Oklassificerat",
  "attachment.bsoCategory.ServiceForms": "Serviceformulär",
  "attachment.bsoCategory.RegistrationDocument": "Registreringsdokument",
  "attachment.bsoCategory.ShopInside": "Bild på butikens interiör",
  "attachment.bsoCategory.ShopImageMigration": "Migrering av butiksbild",
  "attachment.bsoCategory.ShopImage": "Bild på butikens fasad",
  "attachment.uploadButton": "Ladda upp {{category}}",
  "attachment.uploadDropdown": "Ladda upp en fil"
}